import React from "react";

const RowDeleteModal = ({ id, handleDelete }) => {
  return (
    <div
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      id={id}
      // id="mappen_beheren_delete_modal"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{"\u00A0"}</h5>

            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <div id="delete-side">
              <div id="delete-side-img"></div>
              <div className="delete-side-div">
                <span className="delete-side-text">
                  Weet u zeker dat u de geselecteerde rijen wilt verwijderen?
                </span>
              </div>
              <div className="delete-side">
                <div className="delete-side-cancel">
                  <a
                    className="button back"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    Annuleren
                  </a>
                </div>
                <div className="delete-side-ok">
                  <a className="button delete" onClick={handleDelete}>
                    regels{"\u00A0"}verwijderen
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer"></div>
        </div>
      </div>
    </div>
  );
};

export default RowDeleteModal;
